import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import BaseButton from '@/components/ui/Button/Button';

const helperTextStyle = {
  '& .MuiFormHelperText-root': {
    position: 'absolute',
    top: '100%',
  },
};

export const DesktopContentWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  maxWidth: 746,
  width: '70%',
  zIndex: 0,

  marginBottom: theme.spacing(5),
  marginTop: theme.spacing(4),

  ...helperTextStyle,
}));

export const Duration = styled(Typography)(({ theme }) => ({
  margin: theme.spacing(3, 0),
  width: 334,
}));

export const MobileContentWrapper = styled('div')(({ theme }) => ({
  width: 320,
  margin: '0px auto',
  textAlign: 'center',
  position: 'relative',
  zIndex: 0,
  padding: theme.spacing(3.5, 0),

  ...helperTextStyle,
}));

export const Button = styled(BaseButton)(() => ({
  width: 278,
}));

export const Checkboxes = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: 360,
  marginBottom: theme.spacing(2.5),

  '& > label': {
    marginRight: theme.spacing(3),
  },
  '& > label:last-of-type': {
    marginRight: theme.spacing(0),
  },
}));
